import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

const ProtectedRoute: React.FC = () => {
    const { firebaseUser, loading } = useAuth();
    const location = useLocation();

    // Show loading state while authentication is being checked
    if (loading) {
        return <div>Loading...</div>;
    }

    if (!firebaseUser) {
        console.log(".... please login");
        if (!location.pathname.includes("/login")) {
            console.log(".... redirecting to login");
            return <Navigate to="/login" />;
        }
    }

    // Render the nested routes via Outlet.
    return <Outlet />;
};

export default ProtectedRoute;
